module.exports = __webpack_public_path__ + "static/media/xls.f1cd3522.svg";